module.exports = __webpack_public_path__ + "img/eraser-icon.34c3de87.png";